import React from 'react';
import { Button } from 'antd';
import { getApiBaseUrl } from '../../utils';

export function UnauthorizedPage() {
  const startLogin = () => {
    const url = getApiBaseUrl() + '/login';
    window.location.href = url;
  };

  return (
    <div style={{ padding: '15rem 0', textAlign: 'center' }}>
      <h1>Hata!</h1>
      <h3>Bu uygulamayı kullanmak için yetkiniz bulunmuyor.</h3>
      <p>
        Detaylı bilgi için <a href="mailto:anaveridestek@rsnet2.com.tr">anaveridestek@rsnet2.com.tr</a> adresiyle iletişime geçebilirsiniz.
      </p>
      <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
        Tekrar dene
      </Button>
    </div>
  );
}
